"use client";

import { Account24 } from "@/components/icons/Account";
import styles from "./Header.module.css";
import { useLoggedIn } from "@frend-digital/centra/client";
import { IconButton } from "@/components/ui/IconButton";
import { Link } from "@/i18n/Link";
import { AccountModalTrigger } from "@/features/account/AccountModal";
import { Suspense } from "react";
import { ACCOUNT_PATHS } from "@/features/account/config";
import { useTranslations } from "@/i18n/client";

const UnsuspendedAccountbutton = () => {
	const { data: isLoggedIn } = useLoggedIn();
	const t = useTranslations();

	const Component = isLoggedIn ? Link : AccountModalTrigger;

	return (
		<IconButton asChild aria-label={isLoggedIn ? t("Account") : t("Login")}>
			<Component href={ACCOUNT_PATHS.ROOT} mode="login">
				<div className={isLoggedIn ? styles.loggedInAccountWrapper : undefined}>
					<Account24 className={isLoggedIn ? styles.loggedInAccountIcon : undefined} />
				</div>
			</Component>
		</IconButton>
	);
};

export const AccountButton = () => (
	<Suspense>
		<UnsuspendedAccountbutton />
	</Suspense>
);
